const appConfig = {
    "API_URL": "http://127.0.0.1:8000",
    "API_NAME": "Equipment Financing App API"
   };

   module.exports = appConfig;